module.exports = __webpack_public_path__ + "assets/img/container-android1.b4e3b8f.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/container-android1.png
// module id = DeZu
// module chunks = 50